import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '../../app.config';
import { NavData } from "../Models/NavData";
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../institution/ph-bhp-feature-package-insitution-management.service';

import { DACH_Countries } from 'src/app/chc/Models/DACH_Countries';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, OnDestroy {
  navData: Array<NavData> = [];
  filterPackageData: Array<NavData>;
  subscription: Subscription;
  subscriptionUser: Subscription;
  appUrl;
  InstitutionsList: Array<any>;
  packageID;
  groupPackageID;
  roleId;
  institutions;
  sopUrl: Array<String> = [
    '/evaluation/observeSOP/statistical',
    '/sopObserve/newObserve',
    '/sopObserve/observeProtocol',
    '/evaluation/observeSOP/processCompliance',
    '/evaluation/observeSOP/frequencyDistribution',
    '/evaluation/observeSOP/subStepCompliance',
    '/evaluation/observeSOP/sopIndividualOverview',
    '/evaluation/observeSOP/sopComments'
  ]

  observeUrl: Array<String> = [
    '/evaluation/observeObservation/statistical',
    '/observe/newObserve',
    '/observe/observeObservationProtocol',
    '/observe/managequota',
    '/evaluation/observe/overallCompliance',
    '/evaluation/observe/fivemoments',
    '/evaluation/observe/StatisticsBeforeAsepticProcedures',
    '/evaluation/observe/individualOverview',
    '/evaluation/observe/comments',
    '/evaluation/observe/quota'
  ];

  navDataItems: any = {
    dashboard: {
      navTitle: "LAYOUT_MODULE.DASHBOARD",
      navUrl: "/dashboard",
      navIcon: "dashboard",
      navIconActive: "dashboard",
      svg: 'assets/ph-bhp-layout/svg/menu/dashboard.svg',
      filterPackageID: 0
    },
    evaluation: {
      navIcon: "edit",
      navTitle: "LAYOUT_MODULE.EVALUATION",
      navUrl: "/evaluation",
      navIconActive: "edit",
      svg: 'assets/ph-bhp-layout/svg/menu/evaluation.svg',
      filterPackageID: 0,
      tabs: [
        // {
        //   name: "EVALUATION.SUMMARISED_REPORT_OK",
        //   navUrl: "/evaluation/reportSop"
        // },
        {
          name: "EVALUATION.MY_HYGIENE_SOP",
          navUrl: "/evaluation/observeSOP/statistical"
        },
        {
          name: TranslationKeys.LayoutModule.Observe,
          navUrl: "/evaluation/observeObservation/statistical"
        },
        {
          name: "LAYOUT_MODULE.HYGIENE_CHECK",
          navUrl: "/evaluation/hygiene-check/statistical"
        },
        {
          name: "CONFIGURE.CONSUMPTION",
          navUrl: "/evaluation/consumption/statistical"
        }
      ]
    },
    elearning: {
      navIcon: "library_books",
      navTitle: "LAYOUT_MODULE.E_LEARNING",
      navUrl: "/elearning",
      navIconActive: "library_books",
      svg: 'assets/ph-bhp-layout/svg/menu/elearning.svg',
      filterPackageID: 0,
    },
    check: {
      navIcon: "question_answer",
      navTitle: "LAYOUT_MODULE.HYGIENE_CHECK",
      navUrl: "/hygiene-check-menu",
      navIconActive: "question_answer",
      svg: 'assets/ph-bhp-layout/svg/menu/hygiene-check.svg',
      filterPackageID: 0,
      tabs: [
        {
          name: "CHECK.NEW_HYGIENE_CHECK_TITLE",
          navUrl: "/hygiene-check-menu/new-hygiene-check"
        },
        {
          name: "CHECK.OVERVIEW",
          navUrl: "/hygiene-check-menu/hygiene-check"
        },
        {
          name: "CHECK.EDITOR_TITLE",
          navUrl: "/hygiene-check-menu/hygiene-check-editor"
        }
      ]
    },
    checkEditor: {
      navIcon: "question_answer",
      navTitle: "CHECK.HYGIENE_CHECK_EDITOR",
      navUrl: "/hygiene-check-editor",
      navIconActive: "question_answer",
      svg: 'assets/ph-bhp-layout/svg/menu/hygiene-check.svg',
      filterPackageID: 0
    },
    sop: {
      navTitle: "LAYOUT_MODULE.SOP",
      navUrl: "/sopObserve",
      navIcon: "camera_alt",
      navIconActive: "camera_alt",
      svg: 'assets/ph-bhp-layout/svg/menu/sop.svg',
      filterPackageID: 1,
      tabs: [
        {
          name: "SOP_OBSERVATION.NEW_OBSERVATION",
          navUrl: "/sopObserve/newObserve"
        },
        {
          name: TranslationKeys.SOPObservation.ObservationProtocol,
          navUrl: "/sopObserve/observeProtocol"
        },
        {
          name: "LAYOUT_MODULE.SOP_EDITOR",
          navUrl: "/sopObserve/sopEditor"
        }
      ]
    },
    sopEditor: {
      navIconActive: "edit_note",
      navIcon: "edit_note",
      navTitle: "LAYOUT_MODULE.SOP_EDITOR",
      navUrl: "/sop",
      svg: 'assets/ph-bhp-layout/svg/menu/sop-editor.svg',
      filterPackageID: 1
    },
    observe: {
      navIcon: "remove_red_eye",
      navIconActive: "remove_red_eye",
      navTitle: "LAYOUT_MODULE.OBSERVE",
      navUrl: "/observe",
      svg: 'assets/ph-bhp-layout/svg/menu/observe.svg',
      filterPackageID: 2,
      tabs: [
        {
          name: "CONFIGURE.OBSERVATION",
          navUrl: "/observe/newObserve"
        },
        {
          name: TranslationKeys.SOPObservation.ObservationProtocol,
          navUrl: "/observe/observeObservationProtocol"
        },
        {
          name: TranslationKeys.Configure.Quota,
          navUrl: "/observe/managequota"
        }
      ]
    },
    consumption: {
      navIcon: "exit_to_app",
      navIconActive: "exit_to_app",
      navTitle: "CONFIGURE.CONSUMPTION",
      navUrl: "/consumption",
      svg: 'assets/ph-bhp-layout/svg/menu/consumption.svg',
      filterPackageID: 0,
      tabs: [
        {
          name: "CONSUMPTION.CONSUMPTION.NEW",
          navUrl: "/consumption/new"
        },
        {
          name: "CONSUMPTION.CONSUMPTION.SUMMARISED",
          navUrl: "/consumption/past"
        }
      ]
    },
    institutions: {
      navIconActive: "location_city",
      navIcon: "location_city",
      navTitle: "LAYOUT_MODULE.INSTITUTION",
      navUrl: "/institution",
      svg: 'assets/ph-bhp-layout/svg/menu/institutions.svg',
      filterPackageID: 0
    },
    users: {
      navIconActive: "supervisor_account",
      navIcon: "supervisor_account",
      navTitle: "LAYOUT_MODULE.USERS",
      navUrl: "/user",
      svg: 'assets/ph-bhp-layout/svg/menu/users.svg',
      filterPackageID: 0
    },
    configure: {
      navIconActive: "settings",
      navIcon: "settings",
      navTitle: "LAYOUT_MODULE.CONFIGURE",
      navUrl: "/configure",
      svg: 'assets/ph-bhp-layout/svg/menu/config.svg',
      filterPackageID: 0
    }
  }

  dach_Countries: any;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(public config: AppConfig,
    private router: Router,
    public layoutService: PHBHPLayoutPackageService,
    public institutionService: PHBHPFeaturePackageInsitutionManagementService,
    public userService: PHBHPListApiService) { }

  ngOnInit() {
    this.appUrl = {
      androidUrl: this.config.androidUrl,
      iosUrl: this.config.iosUrl
    }
    this.dach_Countries = DACH_Countries;

    if (this.config.userData) {
      this.roleId = this.config.userData.roleName.roleId;
      this.institutions = this.config.institutions;
      this.loadMenu();
    } else {
      this.subscriptionUser = this.config.userSubject.asObservable().subscribe(res => {
        this.roleId = this.config.userData.roleName.roleId;
        this.institutions = this.config.institutions;
        this.loadMenu();
      })
    }
    if (this.InstitutionsList && this.layoutService.institutionID && this.roleId != 1)
      this.loadMenu();

    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.loadMenu();
    });

    var activeInterval = setInterval(() => {
      this.userService.getUserIsActive(this.config.userData.userId).subscribe((isActive: boolean) => {
        if (isActive == null) return;

        if (!isActive) {
          clearInterval(activeInterval);
          this.layoutService.showError(this.layoutService.translateText('AUTHORIZATION.ERROR_USER_NOT_ACTIVE'));
          localStorage.clear();
          this.router.navigate(['login']);
        }
      }, (error) => { console.log(error); });
    }, 30000);

  }

  loadMenu() {
    if (this.institutions && this.institutions.length > 0)
      this.getInstitutionsDetails();
    else
      this.configureNavigationMenu();
  }

  getInstitutionsDetails() {
    this.institutionService.getInstitutionsbyId(this.institutions, this.roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      this.configureNavigationMenu();
    })
  }

  configureNavigationMenu() {
    this.userService.getIsEvaluationAccessible(this.config.userData.userId).subscribe((isAvailable: any) => {
      if (this.InstitutionsList && this.InstitutionsList.length > 0 && this.layoutService.institutionID && (this.roleId > 2)) {

        const institution = this.InstitutionsList.find(x => x.institution.institutionID === this.layoutService.institutionID)?.institution;
        let packageId = institution?.packageID;
        if (institution && institution.isGroup) {
          packageId = this.getPackageForInstitutionGroups();
        }
        this.layoutService.packageID = packageId;
        this.layoutService.packageIDSubject.next(packageId);

        // Clear display
        this.navData = [];

        // Always show dashboard
        this.navData.push(this.navDataItems.dashboard);

        // Only show SOP if it is IA or IU and has SOP license
        if (this.layoutService.isMyHygieneSOPLicense(packageId) && (this.roleId == 5 || this.roleId == 4)) {
          if (this.roleId != 5) {
            this.navData.push(this.navDataItems.sop);
          } else {
            // Remove SOP Editor from sop
            var sopTab = { ...this.navDataItems.sop };
            sopTab.tabs = sopTab.tabs.filter(x => x.name != 'LAYOUT_MODULE.SOP_EDITOR');
            this.navData.push(sopTab);
          }
        }

        // Only show SOP Editor if it is GA and has SOP license
        if (this.layoutService.isMyHygieneSOPLicense(packageId) && (this.roleId == 3)) {
          this.navData.push(this.navDataItems.sopEditor);
        }

        // Only show Observe if it is GA(to see manage quota in Observe), IA or IU and has Observe license
        if (this.layoutService.isObserveLicense(packageId) && (this.roleId == 3 || this.roleId == 5 || this.roleId == 4)) {
          if (this.roleId != 5) {
            this.navData.push(this.navDataItems.observe);
          } else {
            var observeTab = { ...this.navDataItems.observe };
            observeTab.tabs = observeTab.tabs.filter(x => x.name != TranslationKeys.Configure.Quota);
            this.navData.push(observeTab);
          }
        }

        // Only show Check if it is IA or IU and has Check license
        if (this.layoutService.isHygieneCheckLicense(packageId) && (this.roleId == 5 || this.roleId == 4)) {
          if (this.roleId == 4) {
            this.navData.push(this.navDataItems.check);
          } else {
            var checkTab = { ...this.navDataItems.check };
            checkTab.tabs = [];
            checkTab.tabs.push(this.navDataItems.check.tabs[0]);
            checkTab.tabs.push(this.navDataItems.check.tabs[1]);
            this.navData.push(checkTab);
          }
        }

        // If IA or IU, show consumption
        if (this.roleId == 5 || this.roleId == 4) {
          this.navData.push(this.navDataItems.consumption);
        }

        // Always show evaluation and e-Learning
        if (this.roleId != 5 || (this.roleId == 5 && isAvailable)) {
          if (this.roleId == 3) {
            this.navData.push(this.navDataItems.evaluation);
          } else {
            var evaluationTab = { ...this.navDataItems.evaluation };
            evaluationTab.tabs = [];
            if (this.layoutService.isMyHygieneSOPLicense(packageId)) {
              evaluationTab.tabs.push(this.navDataItems.evaluation.tabs[0]);
            }

            if (this.layoutService.isObserveLicense(packageId)) {
              evaluationTab.tabs.push(this.navDataItems.evaluation.tabs[1]);
            }

            if (this.layoutService.isHygieneCheckLicense(packageId)) {
              evaluationTab.tabs.push(this.navDataItems.evaluation.tabs[2]);
            }

            evaluationTab.tabs.push(this.navDataItems.evaluation.tabs[3]);
            this.navData.push(evaluationTab);
          }
        }

        this.navData.push(this.navDataItems.elearning);

        // If not IU, show institution, users and configuration
        if (this.roleId != 5) {
          this.navData.push(this.navDataItems.institutions);
          this.navData.push(this.navDataItems.users);
          this.navData.push(this.navDataItems.configure);
        }

        this.filterPackageData = this.navData;
      } else {
        this.navData = [];
        this.navData.push(this.navDataItems.dashboard);
        this.navData.push(this.navDataItems.sopEditor);
        if (this.roleId === 2) {
          this.navData.push(this.navDataItems.checkEditor);
        }

        this.navData.push(this.navDataItems.evaluation);
        this.navData.push(this.navDataItems.elearning);
        this.navData.push(this.navDataItems.institutions);
        this.navData.push(this.navDataItems.users);
        this.navData.push(this.navDataItems.configure);
        this.filterPackageData = this.navData;
      }
    });
  }

  private getPackageForInstitutionGroups() {
    let packageId: number;
    let isSop: boolean = false;
    let isObserve: boolean = false;
    let isHygieneCheck: boolean = false;
    this.InstitutionsList.forEach(element => {
      if (this.layoutService.isMyHygieneSOPLicense(element.institution.packageID)) {
        isSop = true;
      }
      if (this.layoutService.isObserveLicense(element.institution.packageID)) {
        isObserve = true;
      }
      if (this.layoutService.isHygieneCheckLicense(element.institution.packageID)) {
        isHygieneCheck = true;
      }
    });
    if (isSop && !isObserve && !isHygieneCheck) {
      packageId = 1;
    }
    else if (!isSop && isObserve && !isHygieneCheck) {
      packageId = 2;
    }
    else if (isSop && isObserve && !isHygieneCheck) {
      packageId = 3;
    }
    else if (!isSop && !isObserve && isHygieneCheck) {
      packageId = 4;
    }
    else if (isSop && !isObserve && isHygieneCheck) {
      packageId = 5;
    }
    else if (!isSop && isObserve && isHygieneCheck) {
      packageId = 6;
    }
    else if (isSop && isObserve && isHygieneCheck) {
      packageId = 7;
    }
    return packageId;
  }

  childEmit(data: any) {
    if (data.key = 'logOut') {
      this.router.navigate(['login']);
    }
  }

  ngOnDestroy() {
    if (this.subscriptionUser) {
      this.subscriptionUser.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.filterPackageData = this.navData;
  }
}
